export default __webpack_public_path__ + "static/media/Alternative_financing.cde2884b.png";